<template>
  <v-container class="pa-3" fluid v-if="myRun">
    <v-layout wrap>
      <v-flex class="px-2" xs12>
        <v-select
          :items="meridionalPlanes"
          label="Meridional plane"
          v-model="myRun.config.heliospheric_model.plotting.meridional_plane"
        ></v-select>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import runMixin from '@/mixins/run';

export default {
  mixins: [runMixin],
  data() {
    return {
      meridionalPlanes: [
        { text: 'Earth', value: 'Earth' },
        { text: 'Mercury', value: 'Mercury' },
        { text: 'Venus', value: 'Venus' },
        { text: 'Mars', value: 'Mars' },
        { text: 'STEREO-A', value: 'STA' },
        { text: 'STEREO-B', value: 'STB' },
      ],
    };
  },
};
</script>
